const breakpoints = {
  MEDIUM_DESKTOP_SCREEN: 1280,
  SMALL_DESKTOP_SCREEN: 1024,
  TABLET: 980,
  DASHBOARD_BREAKPOINT: 1180
}

export default breakpoints
